import { useReactiveVar } from '@apollo/client'
import { userInfo } from 'api/graphQL/reactiveVars/user'
import { useCallback, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import {
    useEditorActionBarActions,
    useHasHydrated,
} from '../store/EditorActionBarStore'

/**
 * Handles per-user persistence of arePTLinksVisible in localStorage.
 * - Reads from localStorage after hydration (localStorage → store)
 * - Returns function to write to localStorage (store → localStorage)
 */
export const useSyncPTLinksVisibility = () => {
    const {
        syncPTLinksVisibilityFromLocalStorage,
        syncPTLinksVisibilityToLocalStorage,
    } = useEditorActionBarActions()

    const hasHydrated = useHasHydrated()
    const { projectId } = useParams<{ projectId?: string }>()
    const {
        currentUserInfo: { kpUserId: userId },
    } = useReactiveVar(userInfo)

    useEffect(() => {
        if (hasHydrated && userId && projectId) {
            syncPTLinksVisibilityFromLocalStorage({ userId, projectId })
        }
    }, [
        hasHydrated,
        userId,
        projectId,
        syncPTLinksVisibilityFromLocalStorage,
    ])

    const syncToLocalStorage = useCallback(
        (value: boolean) => {
            if (userId && projectId) {
                syncPTLinksVisibilityToLocalStorage({ userId, projectId, value })
            }
        },
        [userId, projectId, syncPTLinksVisibilityToLocalStorage]
    )

    return { syncToLocalStorage }
}
